import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=37c4f87a&scoped=true&"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=0&id=37c4f87a&scoped=true&lang=css&"
import style1 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c4f87a",
  null
  
)

export default component.exports